import ApiService from "./ApiService";

/**
 * Shared by both sign-in paths — the password+2FA login form (RequestPinScreen) and the
 * (currently dormant, not UI-surfaced) OAuth callback screen — since both hand off through the
 * SAME backend one-time-code exchange (`POST /api/session/exchange`; see SessionService.
 * exchangeCode). The backend sets the httpOnly session cookie directly on this response and
 * never echoes the raw session id back — this just returns the sanitized session info so
 * callers can read `expires` (e.g. to bound cached launch creds).
 */
export interface SessionResult {
  status: string;
  expires?: number;
  isAdmin?: boolean;
  email?: string;
}

/**
 * Redeem a one-time login code for the real session. The cookie is set as a side effect of
 * this call (credentials: "include"). Throws if the exchange fails (expired/invalid code) or
 * the response isn't "approved".
 */
export async function exchangeLoginCode(
  loginCode: string
): Promise<SessionResult> {
  const { data } = await ApiService.fetch<{ data: SessionResult }>(
    "POST",
    "/api/session/exchange",
    { loginCode }
  );

  if (data.status !== "approved") {
    throw new Error("Login could not be completed.");
  }

  return data;
}
